import { Parser } from "json2csv";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import formatSubscriber from "../../../utils/format-sub";
import MembershipList from "./membership-list";

const MembershipListController = async ({ req, res, load, locals, api }) => {
  const { query } = req;
  let page = -1;
  if (typeof query.page !== "undefined") {
    page = query.page;
  }

  const allSubs = locals.activeUser.organizationId
    ? await load("subscribersListExport", {
        memberships: true,
        organizationUser: locals.activeUserToRequest._id,
      })
    : await load("subscribersListExport", { memberships: true });

  const formattedSubs = allSubs.subscriptions.data.map(formatSubscriber);
  const fields = [
    "customer_name",
    "customer_email",
    "phoneNumber",
    "plan.interval",
    "created",
    { label: "tenure (months)", value: "tenure" },
    "current_period_start",
    "lastPayment",
    "lifetimeRevenue",
    "status",
    "paymentStatus",
  ];

  const json2csvParser = new Parser({ fields, unwind: ["plan"] });
  const csv = json2csvParser.parse(formattedSubs);

  if (query.customer) {
    if (locals.activeUser.organizationId) {
      await load("subscriberInvoices", {
        customer: query.customer,
        productType: "PRESS",
        organizationUser: locals.activeUserToRequest._id,
      });
    } else {
      await load("subscriberInvoices", {
        customer: query.customer,
        productType: "PRESS",
      });
    }
  }

  if (query.customer && query.price) {
    await load("upcomingInvoice", query);
  }

  const modal = query.modal || {};

  locals.modal = {
    "activity-feed": <ActivityDrawer />,
  }[modal.type];
  res.body = (
    <MembershipList
      allSubs={allSubs}
      subscribers={formattedSubs}
      csvString={csv}
      page={page}
      key="members"
      api={api}
    />
  );
};

export default MembershipListController;
